import { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { toast } from "sonner";
import { Check, Loader2, ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TYPES = ["Kunststof kozijnen", "Deuren", "Schuifpuien", "Complete woning", "Anders / advies"];
const empty = { name: "", email: "", phone: "", address: "", project_type: "Kunststof kozijnen", preferred_date: "", message: "" };

export const QuoteForm = ({ compact = false }) => {
  const [form, setForm] = useState(empty);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.phone || !form.address) {
      toast.error("Vul a.u.b. uw naam, e-mail, telefoon en adres in.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/appointments`, form);
      setDone(true);
      toast.success("Aanvraag verzonden. U ontvangt een bevestiging per e-mail.");
    } catch {
      toast.error("Er ging iets mis. Probeer het later opnieuw.");
    } finally {
      setLoading(false);
    }
  };

  const inp = "w-full bg-white border border-[#E4E4E1] rounded-sm px-4 py-3.5 text-[#222] placeholder-[#222]/35 focus:border-[#2F3438] outline-none transition-colors duration-300";
  const lbl = "block text-xs uppercase tracking-widest text-[#222]/45 mb-2";

  if (done)
    return (
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} data-testid="quote-success" className="bg-[#F7F7F5] rounded-sm p-10 border border-[#E4E4E1]">
        <div className="h-14 w-14 rounded-full bg-[#2F3438] flex items-center justify-center mb-6">
          <Check className="h-7 w-7 text-white" />
        </div>
        <h3 className="font-display text-2xl font-bold mb-3 text-[#2F3438]">Bedankt, {form.name.split(" ")[0]}.</h3>
        <p className="text-[#222]/60 max-w-md">Uw aanvraag is verzonden. U ontvangt een bevestiging op {form.email} en wij nemen binnen één werkdag contact met u op.</p>
      </motion.div>
    );

  return (
    <form onSubmit={submit} data-testid="quote-form" className={`grid grid-cols-1 ${compact ? "" : "sm:grid-cols-2"} gap-5`}>
      <div className={compact ? "" : "sm:col-span-2"}>
        <label className={lbl}>Naam *</label>
        <input data-testid="input-name" className={inp} placeholder="Uw volledige naam" value={form.name} onChange={set("name")} />
      </div>
      <div>
        <label className={lbl}>E-mail *</label>
        <input data-testid="input-email" type="email" className={inp} placeholder="naam@voorbeeld.nl" value={form.email} onChange={set("email")} />
      </div>
      <div>
        <label className={lbl}>Telefoon *</label>
        <input data-testid="input-phone" className={inp} placeholder="06 12345678" value={form.phone} onChange={set("phone")} />
      </div>
      <div className={compact ? "" : "sm:col-span-2"}>
        <label className={lbl}>Adres *</label>
        <input data-testid="input-address" className={inp} placeholder="Straat, plaats" value={form.address} onChange={set("address")} />
      </div>
      <div>
        <label className={lbl}>Type project</label>
        <select data-testid="input-type" className={inp} value={form.project_type} onChange={set("project_type")}>
          {TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
        </select>
      </div>
      <div>
        <label className={lbl}>Voorkeursdatum</label>
        <input data-testid="input-date" type="date" className={inp} value={form.preferred_date} onChange={set("preferred_date")} />
      </div>
      <div className={compact ? "" : "sm:col-span-2"}>
        <label className={lbl}>Bericht</label>
        <textarea data-testid="input-message" rows={4} className={`${inp} resize-none`} placeholder="Vertel ons over uw project (optioneel)" value={form.message} onChange={set("message")} />
      </div>
      <div className={compact ? "" : "sm:col-span-2"}>
        <button type="submit" disabled={loading} data-testid="quote-submit-button"
          className="group inline-flex items-center justify-center gap-3 bg-[#2F3438] text-white px-8 py-4 rounded-sm hover:bg-[#222] transition-colors duration-300 disabled:opacity-60 w-full sm:w-auto">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <>
            <span className="text-sm font-medium">Verstuur aanvraag</span>
            <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform duration-300" />
          </>}
        </button>
      </div>
    </form>
  );
};
